"use strict";
import { MobileAppLogo } from "components/Icons/MobileAppLogo";
import { useIsMobileDrawer } from "components/NavBar/ScreenSizes";
import { useAccount } from "hooks/useAccount";
import { useModalState } from "hooks/useModalState";
import { useTranslation } from "react-i18next";
import { Text } from "rebass";
import { Anchor, Flex, styled, useIsTouchDevice } from "ui/src";
import { ModalName } from "uniswap/src/features/telemetry/constants";
const DOWNLOAD_PADDING_X = 8;
const PinkFilled = {
  backgroundColor: "$accent2",
  color: "$accent1"
};
const DownloadCTA = styled(Anchor, {
  display: "flex",
  flexDirection: "row",
  cursor: "pointer",
  py: "$padding12",
  px: DOWNLOAD_PADDING_X,
  // borderRadius: '$rounded16',
  animation: "200ms",
  "$platform-web": { boxSizing: "content-box" },
  transform: `translateX(-${DOWNLOAD_PADDING_X}px)`,
  gap: "$spacing12",
  textDecorationLine: "none",
  fontWeight: "$book",
  hoverStyle: PinkFilled,
  variants: {
    isMobile: {
      true: PinkFilled
    }
  },
  $sm: {
    transform: "none",
    "$platform-web": { boxSizing: "border-box" }
  }
});
export function DownloadApp({ onClick }) {
  const { t } = useTranslation();
  const { openModal: openGetTheAppModal } = useModalState(ModalName.GetTheApp);
  const isTouchDevice = useIsTouchDevice();
  const isMobileDrawer = useIsMobileDrawer();
  const account = useAccount();
  return <>
      {
    /* <DownloadCTA
      isMobile={isTouchDevice || isMobileDrawer}
      onPress={() => {
        if (onClick) {
          onClick()
        }
        if (isWebIOS || isWebAndroid) {
          openDownloadApp({ element: InterfaceElementName.UNISWAP_WALLET_NAVBAR_MENU_DOWNLOAD_BUTTON })
        } else {
          openGetTheAppModal()
        }
      }}
      data-testid="nav-dropdown-download-app"
    > */
  }
      <Flex flexDirection="row" alignItems="center">
        <MobileAppLogo width={20} height={20} />

        <Text lineHeight="20px" marginLeft="6px">
          Built on top of Uniswap V4
        </Text>
      </Flex>
      {
    /* </DownloadCTA> */
  }
    </>;
}
